function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import getInteractionStatus from '../../utils/get-interaction-status';
import getSegmentId from './get-segment-id';
import hasSegmentFailed from './has-segment-failed';
import isLabelStackUnderSegment from './is-label-stack-under-segment';
export default function getSegmentStatus(interaction, segment) {
  var segmentId = getSegmentId(segment.labelStack);

  // Get the root interaction status info
  var rootInteractionStatus = getInteractionStatus(interaction);
  var rootStatus = rootInteractionStatus.originalInteractionStatus;
  var rootAbortReason = interaction.abortReason;
  var isInteractionsAbortedByNewInteraction = rootStatus === 'ABORTED' && rootAbortReason === 'new_interaction';
  var isInteractionsAbortedByTransition = rootStatus === 'ABORTED' && rootAbortReason === 'transition';
  var status = 'SUCCEEDED';
  var abortReason;

  // Check if this specific segment has failed
  if (segmentId && hasSegmentFailed(interaction.errors, segmentId)) {
    status = 'FAILED';
  } else if (isInteractionsAbortedByNewInteraction) {
    status = 'ABORTED';
    abortReason = 'new_interaction';
  } else if (isInteractionsAbortedByTransition) {
    status = 'ABORTED';
    abortReason = 'transition';
  } else if (segmentId) {
    // Check for active holds that are under this segment
    var _iterator = _createForOfIteratorHelper(interaction.holdActive.values()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var activeHold = _step.value;
        if (isLabelStackUnderSegment(activeHold.labelStack, segmentId)) {
          status = 'ABORTED';
          abortReason = 'timeout';
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return {
    status: status,
    abortReason: abortReason
  };
}